import { Pipe, PipeTransform } from '@angular/core';
import { RmsUtilsService } from '../../core/services';


/**
 * Pipe to return only unique array items
 */
@Pipe({
    name: 'rmsUnique',
    pure: false,
    standalone: false
})
export class RmsUniquePipe implements PipeTransform {

  transform(value: Array<any>, args?: any): any {
    if (!value) {
      return value;
    }
    return RmsUtilsService.arrayUnique(value);
  }

}
